import { useSiteCountryCode } from '@common/hooks/localisation';
import { SupportedCountryCode } from '@seek/je-shared-data/lib/types/brand';

export const useShowCookieConsent = () => {
  const countryCode = useSiteCountryCode();

  return countryCode === SupportedCountryCode.Thailand;
};
